import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Shop = () => {
    const [products, setProducts] = useState([]);
    const [isLive, setIsLive] = useState(false);

    useEffect(() => {
        api.get("/shop/products").then(r => setProducts(r.data || []));
        api.get("/shop/status").then(r => setIsLive(r.data?.provider === "woocommerce"));
    }, []);

    return (
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16" data-testid="shop-page">
            <div className="text-center mb-14">
                <div className="small-caps text-xs text-muted-foreground mb-3">A humble table of goods</div>
                <h1 className="font-serif text-4xl md:text-5xl">Shop</h1>
                <p className="mt-6 max-w-xl mx-auto text-muted-foreground italic">
                    {isLive && products.length === 0
                        ? "The store is connected — new products will appear here the moment you publish them."
                        : isLive
                            ? "Beautifully crafted things — offered at a whisper above cost."
                            : "Beautifully crafted things — the shop is preparing its shelves."}
                </p>
                {isLive && (
                    <div className="mt-3 small-caps text-[10px] text-muted-foreground" data-testid="shop-live-indicator">
                        · Live from our store ·
                    </div>
                )}
            </div>

            {products.length === 0 ? (
                <div className="text-center text-muted-foreground italic max-w-md mx-auto py-8" data-testid="shop-empty">
                    <div className="small-caps text-xs accent-liturgy mb-3">The shelves are quiet</div>
                    Once you publish a product in your store, it will appear here automatically — no code, no redeploy needed.
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="products-grid">
                    {products.map(p => (
                        <div key={p.id} className="missal-card overflow-hidden hover-lift" data-testid={`product-${p.id}`}>
                            <div className="aspect-square overflow-hidden bg-parchment-100">
                                {p.image ? (
                                    <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-muted-foreground italic text-sm">no image yet</div>
                                )}
                            </div>
                            <div className="p-6">
                                <h3 className="font-serif text-xl">{p.title}</h3>
                                <div className="mt-1 small-caps text-xs accent-liturgy">{p.price}</div>
                                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.description}</p>
                                <div className="mt-5 flex items-center gap-2 flex-wrap">
                                    {p.url ? (
                                        <a href={p.url} target="_blank" rel="noopener noreferrer"
                                           className="px-4 py-2 bg-liturgy text-white text-xs small-caps hover:opacity-90 transition"
                                           data-testid={`buy-${p.id}`}>
                                            View in Store
                                        </a>
                                    ) : (
                                        <span className="px-4 py-2 border border-border text-xs small-caps text-muted-foreground" data-testid={`buy-${p.id}`}>
                                            Coming Soon
                                        </span>
                                    )}
                                    {p.in_stock === false && (
                                        <span className="px-3 py-2 text-xs small-caps text-muted-foreground italic">out of stock</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Shop;
